import { Injectable } from "@angular/core";

// Tymczasowy magazyn plików dla attachmentów forum.
// Pliki trzymamy lokalnie do momentu utworzenia threadu lub posta.
// Po dodaniu thread/post pobieramy zapisane plik i uploadujemy je do S3
// Dzięki temu zachowujemy poprawny flow NgRx:
// 1. create thread/post
// 2. upload plików do S3
// 3. create attachment metadata
@Injectable({
  providedIn: "root",
})
export class ForumPendingAttachmentsService {
  private readonly attachmentsByRequestId = new Map<string, File[]>();

  set(requestId: string, files: File[]): void {
    this.attachmentsByRequestId.set(requestId, files);
  }

  peek(requestId: string): File[] {
    return this.attachmentsByRequestId.get(requestId) || [];
  }

  consume(requestId: string): File[] {
    const files = this.attachmentsByRequestId.get(requestId) || [];
    this.attachmentsByRequestId.delete(requestId);
    return files;
  }
}
